import { render, staticRenderFns } from "./PracticeSessions.vue?vue&type=template&id=488d4d76&"
import script from "./PracticeSessions.vue?vue&type=script&lang=js&"
export * from "./PracticeSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports